import React from "react";
import { Award, GraduationCap, CheckCircle } from "lucide-react";
import { motion } from "framer-motion";
import ProgramPageLayout from "../../components/shared/ProgramPageLayout";

const PreCollege: React.FC = () => {
  return (
    <ProgramPageLayout slug="pre-college" theme="orange">
      {(program) => (
        <>
          {/* Program Features from Database */}
          {program.features && program.features.length > 0 && (
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
            >
              <h2 className="text-3xl font-bold text-gray-900 mb-8">Program Features</h2>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12">
                {program.features.map((feature, index) => (
                  <motion.div
                    key={index}
                    initial={{ opacity: 0, x: -20 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ duration: 0.5, delay: 0.1 * index }}
                    className="flex items-start space-x-4 p-6 bg-white rounded-xl shadow-sm border border-gray-100 hover:shadow-md transition-shadow"
                  >
                    <div className="flex-shrink-0">
                      <CheckCircle className="h-6 w-6 text-orange-500" />
                    </div>
                    <div>
                      <h3 className="font-semibold text-gray-900">{feature}</h3>
                    </div>
                  </motion.div>
                ))}
              </div>
            </motion.div>
          )}

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            <h2 className="text-3xl font-bold text-gray-900 mb-8">Program Overview</h2>
            <p className="text-gray-700 mb-6 leading-relaxed">
              Our Pre-Collage Preparation Program is designed to equip students with the knowledge, skills, and confidence needed to succeed in college. The program covers academic preparation, college application guidance, and essential life skills for college success.
            </p>

            <h3 className="text-2xl font-bold text-gray-900 mb-4 mt-8">Program Components</h3>
            <ul className="space-y-3 mb-8">
              <li className="flex items-start">
                <GraduationCap className="h-5 w-5 text-orange-600 mr-3 mt-1 flex-shrink-0" />
                <span className="text-gray-700">College application strategy and essay writing</span>
              </li>
              <li className="flex items-start">
                <GraduationCap className="h-5 w-5 text-orange-600 mr-3 mt-1 flex-shrink-0" />
                <span className="text-gray-700">SAT/ACT preparation and test-taking strategies</span>
              </li>
              <li className="flex items-start">
                <GraduationCap className="h-5 w-5 text-orange-600 mr-3 mt-1 flex-shrink-0" />
                <span className="text-gray-700">Academic skill development (research, writing, critical thinking)</span>
              </li>
              <li className="flex items-start">
                <GraduationCap className="h-5 w-5 text-orange-600 mr-3 mt-1 flex-shrink-0" />
                <span className="text-gray-700">College readiness workshops</span>
              </li>
              <li className="flex items-start">
                <GraduationCap className="h-5 w-5 text-orange-600 mr-3 mt-1 flex-shrink-0" />
                <span className="text-gray-700">Financial aid and scholarship guidance</span>
              </li>
            </ul>

            <h3 className="text-2xl font-bold text-gray-900 mb-4 mt-8">Benefits</h3>
            <ul className="space-y-3 mb-8">
              <li className="flex items-start">
                <Award className="h-5 w-5 text-orange-600 mr-3 mt-1 flex-shrink-0" />
                <span className="text-gray-700">Increased college acceptance rates</span>
              </li>
              <li className="flex items-start">
                <Award className="h-5 w-5 text-orange-600 mr-3 mt-1 flex-shrink-0" />
                <span className="text-gray-700">Better prepared for college-level coursework</span>
              </li>
              <li className="flex items-start">
                <Award className="h-5 w-5 text-orange-600 mr-3 mt-1 flex-shrink-0" />
                <span className="text-gray-700">Enhanced time management and study skills</span>
              </li>
              <li className="flex items-start">
                <Award className="h-5 w-5 text-orange-600 mr-3 mt-1 flex-shrink-0" />
                <span className="text-gray-700">Confidence in college transition</span>
              </li>
            </ul>
          </motion.div>
        </>
      )}
    </ProgramPageLayout>
  );
};

export default PreCollege;

